<nav mat-tab-nav-bar>
  <a mat-tab-link routerLink="/loads/sepas"> Sepa </a>
  <a mat-tab-link routerLink="/loads/soforts"> Sofort </a>
  <a mat-tab-link *ngIf="currentUserIsAdmin() || currentUserIsCompliance()" routerLink="/loads/annual-fee"> Annual Fee </a>
  <a mat-tab-link routerLink="/loads/btl"> BTL </a>
</nav>

<!-- this is merely a template for the tabs in sub-components -->
